/**
 * Created by tofael on 7/27/18.
 */
import React from 'react';
import {LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer} from 'recharts';


const styles = {
  root: {
    background: '#ffffff',
    padding: 10
  }
};

const LineChartComponent = ({title, data, dataKey}) => (
  <div style={styles.root}>
    <h3>{title}</h3>
    <ResponsiveContainer width='100%' height={300}>
      <LineChart
        width="100%"
        height={300}
        data={data}
        margin={{top: 5, right: 30, left: 20, bottom: 5}}>
          <XAxis dataKey="name"/>
          <YAxis/>
          <CartesianGrid strokeDasharray="3 3"/>
          <Tooltip/>
          <Legend />
          <Line type="monotone" dataKey={dataKey} stroke="#82ca9d" />
      </LineChart>
    </ResponsiveContainer>
  </div>
);
export default LineChartComponent;


// WEBPACK FOOTER //
// ./src/screens/stats/line-chart.js